import r2wc from '@r2wc/react-to-web-component';
import React from 'react';
import NavButton from '../components/NavButton';

const NavItem = (props) => {
    return (
      <NavButton {...props}></NavButton>
    );
}

export default NavItem;

const EmNavItem = r2wc(NavItem, {
  props: {
    classes:"string",
    ctaaction:"json",
    data:"json",
    menuactive:"boolean",
    href: "string",
    icon:"string",
    target: "string",
    title: "string"
  },
});
customElements.define("em-nav-item", EmNavItem);
